import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=b9f9bf98&"
import script from "./CustomCard.vue?vue&type=script&lang=ts&"
export * from "./CustomCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports